import React from 'react';
import { Link } from 'react-router-dom';
import ListMessages from '../ListMessages/ListMessages';
import { useAuth } from '../../contexts/AuthContext';
import NavigationBar from '../NavigationBar/NavigationBar';
import Footer from '../Footer/Footer';
import './MessagesPage.css'; 

const MessagesPage = () => {
  const { state } = useAuth();
  
  if (!state.isLoggedIn) {
    return (
      <>
        <NavigationBar />
        <div className="container">
          <div className="text-center p-5">
            <h2>Please log in to view your document history</h2>
            <div className="mt-4">
              <Link to="/login" className="btn btn-primary">Log in</Link>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <NavigationBar />
      <div className="container messages-container">
        <div className="messages-header">
          <h1 className="text-center">Document Generation History</h1>
        </div>
        
        <div className="row justify-content-center">
          <div className="col-md-10">
            
            <div className="messages-card">
              <ListMessages />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MessagesPage;
